'use client';
import { useIsMobile } from '@/shared/hooks/useIsMobile';

import { HomeGamesWrapper } from './styles';

import { PopularGamesSection } from '@/widgets/game-sections/ui/popular-games-section';
import { RecordWinSection } from '@/widgets/game-sections/ui/record-win-section';
import { JackpotSection } from '@/widgets/game-sections/ui/jackpot-section';
import { useGameNavigation } from '@/shared/hooks/useGameNavigation';
import { useHomeGames } from '@/widgets/game-sections/model/hooks';
import { HOME_GAME_SECTION_IDS } from '@/widgets/game-sections/ui/home-games-types';
import type { HomeGameSectionsProps } from './home-game-sections-types';

export const HomeGameSectionsContent = ({
  initialHomeGames,
  openNotAllowedModal,
}: HomeGameSectionsProps) => {
  const {
    data: homeGamesData,
    error: homeGamesError,
    isAuth,
  } = useHomeGames(initialHomeGames);

  const isMobile = useIsMobile();
  const { onGameClick } = useGameNavigation({ isMobile, isAuth });

  const hasAnyGames = homeGamesData
    ? HOME_GAME_SECTION_IDS.some((key) => (homeGamesData[key]?.length ?? 0) > 0)
    : null;

  return (
    <HomeGamesWrapper $hasScroll={true}>
      <PopularGamesSection
        homeGamesData={homeGamesData}
        homeGamesError={homeGamesError}
        hasAnyGames={hasAnyGames}
        openNotAllowedModal={openNotAllowedModal}
        setCurrentGame={onGameClick}
      />

      <RecordWinSection />

      <JackpotSection />
    </HomeGamesWrapper>
  );
};
